// src/pages/TermsPage.js
import React, { useContext } from "react";
import { LangContext } from "../lang/LangProvider";
import Seo from "../components/Seo";
import { getRegistration, getServiceStatusNotice } from "../config/compliance";
import "./TermsPage.css";

// Revisione 29/09/2026: il servizio di consulenza non è avviato. "AlphaFrame Analytics" è il
// nome del Sito, non il soggetto iscritto all'Albo né il soggetto giuridico responsabile.
const TermsPage = () => {
  const { lang } = useContext(LangContext);
  const notice = getServiceStatusNotice(lang);

  const content = {
    it: {
      title: "Termini di Utilizzo",
      updated: "Ultimo aggiornamento: settembre 2026",
      sections: [
        {
          heading: "1. Accettazione dei termini",
          body: `Accedendo al sito AlphaFrame Analytics (di seguito "Sito") e ai contenuti in esso disponibili, l'utente accetta integralmente i presenti Termini di Utilizzo. Se non si accettano tali termini, si invita a non utilizzare il Sito.`,
        },
        {
          heading: "2. Natura dei contenuti",
          body: `I contenuti pubblicati su questo Sito hanno finalità esclusivamente informative ed educative. Le analisi, i modelli e gli articoli presenti non costituiscono consulenza in materia di investimenti, raccomandazione personalizzata né sollecitazione all'acquisto o alla vendita di strumenti finanziari ai sensi del D.Lgs. 58/1998 (TUF).`,
        },
        {
          heading: "3. Stato del servizio e iscrizione del titolare",
          body: `${notice.paras.join(" ")} ${getRegistration("it")} "AlphaFrame Analytics" è il nome del Sito e non è un soggetto iscritto all'Albo. L'iscrizione all'Albo non comporta approvazione dei contenuti del Sito da parte dell'OCF o della CONSOB. Le informazioni del Sito si riferiscono all'ordinamento italiano e non implicano alcuna autorizzazione a operare in altri Paesi.`,
        },
        {
          heading: "4. Limitazione di responsabilità",
          body: `Il titolare del Sito non garantisce l'accuratezza, la completezza o l'aggiornamento dei contenuti. L'utilizzo delle informazioni e degli strumenti presenti sul Sito avviene a rischio esclusivo dell'utente, nei limiti consentiti dalla legge. Il titolare del Sito non risponde di perdite o danni derivanti dall'uso dei contenuti o degli strumenti interattivi (simulatori, calcolatori, ecc.), salvi i casi di dolo o colpa grave e le altre ipotesi in cui la responsabilità non può essere esclusa per legge.`,
        },
        {
          heading: "5. Strumenti interattivi e simulatori",
          body: `I simulatori e i tool disponibili sul Sito hanno scopo puramente didattico e illustrativo. Si basano su ipotesi dichiarate in ciascuno strumento; i risultati non rappresentano previsioni né garanzie di rendimento e non costituiscono raccomandazioni personalizzate. Le performance passate o simulate non sono indicative di quelle future.`,
        },
        {
          heading: "6. Proprietà intellettuale",
          body: `I contenuti del Sito (testi, grafici, modelli, codici, logo) sono di proprietà del titolare del Sito, salvo diversa indicazione. È vietata la riproduzione, distribuzione o modifica senza autorizzazione scritta.`,
        },
        {
          heading: "7. Link esterni",
          body: `Il Sito può contenere link a siti di terzi. Il titolare del Sito non è responsabile del contenuto, delle politiche sulla privacy o delle pratiche di tali siti.`,
        },
        {
          heading: "8. Modifiche ai termini",
          body: `I presenti Termini possono essere modificati in qualsiasi momento. Le modifiche sono efficaci dalla data di pubblicazione sul Sito.`,
        },
        {
          heading: "9. Legge applicabile",
          body: `I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia è competente il Foro di Padova, salvo diversa disposizione inderogabile di legge (inclusa quella a tutela del consumatore).`,
        },
        {
          heading: "10. Contatti",
          body: `Per informazioni generali: alphaframeanalytics.it@gmail.com. Questo recapito non consente il conferimento di incarichi di consulenza.`,
        },
      ],
    },
    en: {
      title: "Terms of Use",
      updated: "Last updated: September 2026",
      sections: [
        {
          heading: "1. Acceptance of Terms",
          body: `By accessing the AlphaFrame Analytics website (hereinafter "Site") and its content, you fully accept these Terms of Use. If you do not accept these terms, please do not use the Site.`,
        },
        {
          heading: "2. Nature of Content",
          body: `The content published on this Site is for informational and educational purposes only. Analyses, models and articles do not constitute investment advice, personalised recommendations or solicitations to buy or sell financial instruments under Italian Legislative Decree 58/1998 (TUF).`,
        },
        {
          heading: "3. Service Status and Owner's Registration",
          body: `${getServiceStatusNotice("en").paras.join(" ")} ${getRegistration("en")} "AlphaFrame Analytics" is the name of the Site and is not a registered entity. Registration does not imply approval of the Site's content by the OCF or CONSOB. The information on the Site refers to the Italian legal framework and does not imply any authorisation to operate in other countries.`,
        },
        {
          heading: "4. Limitation of Liability",
          body: `The Site owner does not guarantee the accuracy, completeness or timeliness of the content. Use of the information and tools on the Site is at the user's own risk, to the extent permitted by law. The Site owner is not liable for losses or damages arising from the use of content or interactive tools (simulators, calculators, etc.), except in cases of wilful misconduct or gross negligence and other cases where liability cannot be excluded by law.`,
        },
        {
          heading: "5. Interactive Tools & Simulators",
          body: `Simulators and tools available on the Site are for purely educational and illustrative purposes. They rely on the assumptions stated in each tool; results do not represent forecasts or performance guarantees and are not personalised recommendations. Past or simulated performance is not indicative of future results.`,
        },
        {
          heading: "6. Intellectual Property",
          body: `The Site content (text, charts, models, code, logo) is the property of the Site owner unless otherwise stated. Reproduction, distribution or modification without written consent is prohibited.`,
        },
        {
          heading: "7. External Links",
          body: `The Site may contain links to third-party websites. The Site owner is not responsible for the content, privacy policies or practices of such sites.`,
        },
        {
          heading: "8. Changes to Terms",
          body: `These Terms may be modified at any time. Changes take effect upon publication on the Site.`,
        },
        {
          heading: "9. Governing Law",
          body: `These Terms are governed by Italian law. Any dispute shall be subject to the jurisdiction of the Court of Padua, unless otherwise required by mandatory law (including consumer protection rules).`,
        },
        {
          heading: "10. Contact",
          body: `For general information: alphaframeanalytics.it@gmail.com. This contact cannot be used to confer investment advisory engagements.`,
        },
      ],
    },
  };

  const c = lang === "en" ? content.en : content.it;

  return (
    <>
      <Seo
        title={c.title}
        description={
          lang === "en"
            ? "Terms of use for AlphaFrame Analytics — informational and educational financial content and simulation tools."
            : "Termini di utilizzo di AlphaFrame Analytics — contenuti finanziari informativi ed educativi e strumenti di simulazione."
        }
        path={`/${lang}/terms`}
      />
      <div className="terms-bg">
        <div className="terms-container">
          <h1 className="terms-title">{c.title}</h1>
          <p className="terms-updated">{c.updated}</p>
          {c.sections.map((s) => (
            <section key={s.heading} className="terms-section">
              <h2>{s.heading}</h2>
              <p>{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </>
  );
};

export default TermsPage;
